import { withPageAuthGuard } from '@zep/auth';
import { withPageSuspense } from '@zep/next';
import { withServerSideTranslations } from '@zep/next/server';

import { MyAppPageView } from '../../../views';

const MyAppPage = () => {
  return <MyAppPageView />;
};

export default withPageSuspense(
  withPageAuthGuard(MyAppPage, {
    suspense: true,
  }),
);
export const getStaticProps = withServerSideTranslations([
  'common',
  'accounts',
]);
